import {
  LayoutDashboard,
  User,
  Users,
  GraduationCap,
  BookOpen,
  Clock,
  Calendar,
  DollarSign,
  FileText,
  CheckSquare,
  MessageSquare,
  ClipboardList,
  CreditCard,
  Bus,
  BarChart3,
  UserCog,
  CalendarDays,
  WalletCards,
} from "lucide-react";

/**
 * Staff sidebar nav — post hub-restructure.
 *
 * PERSONAL & CLASSES:
 * Staff member's own pages. These are not hub links.
 *
 * MANAGE:
 * Hub-based management areas.
 *
 * OPERATIONS:
 * Non-hub operational features such as leave management and chat.
 *
 * Permission arrays are preserved for hub links. Sidebar.jsx should check:
 * item.permission.some(p => userPermissions.includes(p))
 */

export const staffNavData = [
  {
    category: "PERSONAL & CLASSES",
    items: [
      {
        title: "Home",
        icon: LayoutDashboard,
        url: "/staff-home",
      },
      {
        title: "Analytics",
        icon: BarChart3,
        url: "/staff-panel/analytics",
      },
      {
        title: "My Profile",
        icon: User,
        url: "/staff-panel/my-profile",
      },
      {
        title: "My Class",
        icon: GraduationCap,
        url: "/staff-panel/my-class",
        isClassTeacherOnly: true,
      },
      {
        title: "My Subjects",
        icon: BookOpen,
        url: "/staff-panel/my-subjects",
      },
      {
        title: "Mark Attendance",
        icon: CheckSquare,
        url: "/staff-panel/my-class/attendance",
        isClassTeacherOnly: true,
      },
      {
        title: "My Timetable",
        icon: Clock,
        url: "/staff-panel/my-timetable",
      },
      {
        title: "My Marks Assignments",
        icon: FileText,
        url: "/staff-panel/marks/my-assignments",
      },
      {
        title: "My Standalone Marks",
        icon: ClipboardList,
        url: "/staff-panel/marks/standalone/my-assignments",
      },
      {
        title: "My Leaves",
        icon: CalendarDays,
        url: "/staff-panel/leaves",
      },
      {
        title: "My Payslips",
        icon: WalletCards,
        url: "/staff-panel/my-payslips",
      },
    ],
  },

  {
    category: "MANAGE",
    items: [
      {
        title: "Staff",
        icon: UserCog,
        url: "/staff-panel/staff-hub",
        // Covers Staff Management + Role Management + Staff Attendance
        permission: [
          "STAFF_MANAGEMENT_VIEW",
          "ROLE_MANAGEMENT_VIEW",
          "STAFF_ATTENDANCE_VIEW",
        ],
      },
      {
        title: "Student & Classes",
        icon: GraduationCap,
        url: "/staff-panel/student-classes",
        // Covers Student Management + Student Attendance
        permission: [
          "STUDENT_MANAGEMENT_VIEW",
          "STUDENT_ATTENDANCE_VIEW",
        ],
      },
      {
        title: "Academics",
        icon: BookOpen,
        url: "/staff-panel/academics",
        // Covers Academic Setup + Subjects Management + Notice Board
        permission: [
          "ACADEMIC_YEAR_VIEW",
          "TIMETABLE_VIEW",
          "ACADEMIC_CALENDAR_VIEW",
          "SYLLABUS_VIEW",
          "NOTICE_VIEW",
          "SUBJECT_MANAGEMENT_VIEW",
        ],
      },
      {
        title: "Exams & Marks",
        icon: FileText,
        url: "/staff-panel/exams",
        permission: ["EXAM_MANAGEMENT_VIEW"],
      },
      {
        title: "Fee Management",
        icon: CreditCard,
        url: "/staff-panel/fees",
        permission: ["FEE_MANAGEMENT_VIEW"],
      },
      {
        title: "Payroll",
        icon: WalletCards,
        url: "/staff-panel/payroll",
        permission: ["PAYROLL_MANAGEMENT_VIEW"],
      },
      {
        title: "Transport",
        icon: Bus,
        url: "/staff-panel/transport",
        permission: [
          "TRANSPORT_MANAGEMENT_VIEW",
          "TRANSPORT_MANAGEMENT_FULL",
        ],
      },
    ],
  },

  {
    category: "OPERATIONS",
    items: [
      {
        title: "Leave Management",
        icon: Calendar,
        permission: "LEAVE_MANAGEMENT_VIEW",
        children: [
          {
            title: "Leave Management",
            url: "/staff-panel/leave-management",
            permission: "LEAVE_MANAGEMENT_VIEW",
          },
          {
            title: "Leave Types",
            url: "/staff-panel/leave-types",
            permission: "LEAVE_MANAGEMENT_VIEW",
          },
          {
            title: "Create Leave Type",
            url: "/staff-panel/leave-types/create",
            permission: "LEAVE_MANAGEMENT_FULL",
          },
        ],
      },
      {
        title: "Chat & Messages",
        icon: MessageSquare,
        url: "/staff/chat",
        permission: "CHAT_USE",
      },
    ],
  },
];

export default staffNavData;